import { useRef } from "react";
import { Toast } from "primereact/toast";
import ProjectGrid from "../../../ModuleGrids/ProjectGrid";
import TaskGrid from "../../../ModuleGrids/TaskGrid";
import JobsGrid from "../../../ModuleGrids/JobsGrid";
import FullkitGrid from "../../../ModuleGrids/FullkitGrid";
import AlertsGrid from "../../../ModuleGrids/AlertsGrid";
import HelpNeededGrid from "../../../ModuleGrids/HelpNeededGrid";
import ViewHeader from "../ViewHeader";
import "./MaximizedView.scss";
export default function MaximizedView({
  item,
  data = [],
  onMinimize,
  onSettings,
  onDeleteSuccess,
  onTitleSave,
}) {
  const toast = useRef(null);

  const handleDeleteSuccess = () => {
    onDeleteSuccess?.();
    // onMinimize();
  };
  const renderView = () => {
    switch (item?.type) {
      case "task":
        return (
          <TaskGrid
            data={data}
            mode="max"
            dataKey={item.moduleId}
            settings={item.settings}
            title={item.title}
          />
        );

      case "fullkit":
        return (
          <FullkitGrid
            data={data}
            mode="max"
            dataKey={item.moduleId}
            settings={item.settings}
            title={item.title}
          />
        );
      case "jobs":
        return (
          <JobsGrid
            data={data}
            mode="max"
            dataKey={item.moduleId}
            settings={item.settings}
            title={item.title}
          />
        );
      case "alerts":
        return (
          <AlertsGrid
            data={data}
            mode="max"
            dataKey={item.moduleId}
            settings={item.settings}
            title={item.title}
          />
        );
      case "helpneeded":
        return (
          <HelpNeededGrid
            data={data}
            mode="max"
            dataKey={item.moduleId}
            settings={item.settings}
            title={item.title}
          />
        );
      default:
        return (
          <ProjectGrid
            data={data}
            mode="max"
            dataKey={item.moduleId}
            settings={item.settings}
            title={item.title}
          />
        );
    }
  };

  return (
    <div className={`maximized-view${data.length > 0 ? " fullheight" : ""}`}>
      <Toast ref={toast} />
      <div className="maximized-view-header" style={{ backgroundColor: item.color }}>
        <ViewHeader
          item={item}
          toast={toast}
          isMaximized={true}
          onMaximize={() => {
            onMinimize();
          }}
          onSettings={() => onSettings(item?.id)}
          onDeleteSuccess={handleDeleteSuccess}
          onTitleSave={onTitleSave}
        />
      </div>
      {renderView()}
    </div>
  );
}
